exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:992px){main{overflow-x:hidden}}.overlay-enter{display:none}", ""]);

// exports
